export default __webpack_public_path__ + "static/media/bg-nft-detail.f5bbc4e6.png";